import React from 'react';
import { LoginStatus } from 'auth';

export function AppHeader() {
  return (
    <div className="appHeader">
      <div className="appHeader__logo">
        <img src="/assets/logos/logo.png" alt="VS logo" />
      </div>
      <LoginStatus/>
    </div>
  );
}
